
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <span class="title">
        {{ editData ? ("Edit refrigerant fluid declaration" | translate) : ("Refrigerant fluid declaration" | translate) }}
      </span>
    </nb-card-header>

    <nb-card-body>
      <div class="form-group">
        <!-- BUILDING (PERIMETER) -->
        <div class="form-field">
          <label for="perimeter">{{ 'Building' | translate }}</label>
          <nb-select
            id="perimeter"
            formControlName="perimeter"
            [status]="form.get('perimeter').invalid ? 'danger' : 'basic'"
            >
            @for (perimeter of perimeters; track perimeter) {
              <nb-option [value]="perimeter.id">
                {{ perimeter.name }}
              </nb-option>
            }
          </nb-select>
        </div>

        <!-- OPERATION TYPE -->
        <div class="form-field">
          <label for="operation_type">{{ 'Operation type' | translate }}</label>
          <nb-select
            id="operation_type"
            formControlName="operation_type"
            [status]="form.get('operation_type').invalid ? 'danger' : 'basic'"
            >
            @for (operationType of operationTypes; track operationType) {
              <nb-option [value]="operationType.id">
                {{ operationType.name }}
              </nb-option>
            }
          </nb-select>
        </div>

        <!--REFRIGERANT TYPE -->
        <div class="form-field">
          <label for="refrigerant_type">{{ 'Fluid type' | translate }}</label>
          <nb-select
            id="refrigerant_type"
            formControlName="refrigerant_type"
            [status]="form.get('refrigerant_type').invalid ? 'danger' : 'basic'"
            >
            @for (type of refrigerantTypes$ | async; track type) {
              <nb-option [value]="type.id">
                {{ type.name }} ({{ "GWP (Global warming potential)" | translate}} = {{ type.gwp_20_years }})
              </nb-option>
            }
          </nb-select>
        </div>

        <!-- EMISSION (QUANTITY OF REGRIGERANT FLUID) -->
        <div class="form-field">
          <label for="emission">{{ "Quantity" | translate }} ({{ "kg" | translate }})</label>
          <input
            nbInput
            id="emission"
            type="number"
            formControlName="emission"
            [status]="form.get('emission').invalid ? 'danger' : 'basic'"
            >
        </div>

        <!-- YEAR -->
        <div class="form-field">
          <label for="year">{{ 'Year' | translate }}</label>
          <input
            nbInput
            id="year"
            type="number"
            formControlName="year"
            [status]="form.get('year').invalid ? 'danger' : 'basic'"
            >
        </div>
      </div>
    </nb-card-body>

    <!-- CANCEL OR SUBMIT -->
    <nb-card-footer class="text-right">
      @if (!loading) {
        <button nbButton type="button" (click)="close()" class="cancel">
          {{ 'Cancel' | translate }}
        </button>
        <button nbButton type="submit" [disabled]="!form.valid" class="ms-3">
          {{ 'OK' | translate }}
        </button>
      }
    </nb-card-footer>
  </nb-card>
</form>